import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//internal import
import TicketService from "../services/TicketService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useTicketSubmit = (id) => {

  const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();
  const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

  const [isModal, setIsModal] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [viewData, setviewData] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);

  // add and update ticket details
  const onSubmit = async (data) => {
    setPageLoading(true);
    try {
      data.images = imageUrl;
      const response = id ? await TicketService.UpdateTicketById(id, data) : await TicketService.addTicket(data);
      if (response?.success) {
        notifySuccess(response.message);
        setIsModal(false);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response.message);
      }
    } catch (error) {
      console.error(error);
      notifyError("Something went wrong.");
    } finally {
      setPageLoading(false);
    }
  };

  //  delete ticket by id 
  const handleDeleteTicket = async (id) => {
    try {
      const response = await TicketService.deleteTicketById(id);
      if (response.success) {
        notifySuccess(response?.message);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response?.message);
      }
      setIsDeleteModal(false);
    }
    catch (error) {
      console.error("error", error);
      notifyError("Something want wrong !");
      setIsDeleteModal(false);
    }
  }

  useEffect(() => {
    reset();
    setValue("status", "Open");
    if (id) {
      (async () => {
        try {
          const res = await TicketService.getTicketById(id);
          const data = res?.data;
          if (res?.success) {
            setviewData(data);
            setValue("subject", data.subject);
            setValue("message", data.message);
            setValue("clientId", data.clientId?._id);
            setValue("projectId", data.projectId?._id);
            setValue("assigneeId", data.assigneeId?._id);
            setValue("status", data.status);
            setImageUrl(data?.images);

          }
        } catch (error) {
          console.error("Error fetching ticket data:", error);
        }
      })();
    }
  }, [isModal, id]);

  return {
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    handleDeleteTicket,
    pageLoading,
    isModal,
    setIsModal,
    isViewModal,
    setIsViewModal,
    isDeleteModal,
    setIsDeleteModal,
    imageUrl,
    setImageUrl,
    viewData,
  }
}

export default useTicketSubmit;